/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MetadataSchema } from './MetadataSchema';
import {
    MetadataSchemaFromJSON,
    MetadataSchemaFromJSONTyped,
    MetadataSchemaToJSON,
} from './MetadataSchema';

/**
 * Payload of enumerated metadata schemas
 * @export
 * @interface MetadataSchemaEnumeration
 */
export interface MetadataSchemaEnumeration {
    /**
     * 
     * @type {Array<MetadataSchema>}
     * @memberof MetadataSchemaEnumeration
     */
    items: Array<MetadataSchema>;
}

/**
 * Check if a given object implements the MetadataSchemaEnumeration interface.
 */
export function instanceOfMetadataSchemaEnumeration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function MetadataSchemaEnumerationFromJSON(json: any): MetadataSchemaEnumeration {
    return MetadataSchemaEnumerationFromJSONTyped(json, false);
}

export function MetadataSchemaEnumerationFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetadataSchemaEnumeration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(MetadataSchemaFromJSON)),
    };
}

export function MetadataSchemaEnumerationToJSON(value?: MetadataSchemaEnumeration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(MetadataSchemaToJSON)),
    };
}

